import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchPagination, SearchResults } from '@uncinc/react-searchkit';

import ArticleCard from '../../../ArticleCard';
import { SearchTopicalArticleHit } from '../../types';
import { EXTERNAL_LINK_ID } from '../../../../config/constants';
import hitTagMapper from '../../../SearchAllContent/helpers/hitTagMapper';

const SearchTopicalResultsArticles: React.FC = () => {
  const { t } = useTranslation();

  const classNames = c('SearchTopical__Results--Articles');

  return (
    <div className={classNames}>
      <h2 className="mb-0">{t('components.search_topical.results.articles')}</h2>
      <SearchResults
        renderItem={(hit: SearchTopicalArticleHit) => {
          const themeTags = hit.theme?.[0] ? hitTagMapper(hit.theme, 'theme') : [];
          const typeTags = hit.article_type?.[0] ? hitTagMapper(hit.article_type, 'article-type') : [];
          const tags = themeTags.concat(typeTags);

          if (hit.article_type_id?.[0] === EXTERNAL_LINK_ID) {
            return (
              <ArticleCard
                title={hit.page_title[0]}
                tags={tags}
                subtitle={hit.body_summarized?.[0]}
                image={hit.image_style_uri?.[0]}
                link={hit.link[0]}
              />
            );
          }
          return (
            <ArticleCard
              title={hit.page_title[0]}
              tags={tags}
              subtitle={hit.body_summarized?.[0]}
              image={hit.image_style_uri?.[0]}
              link={hit.url[0]}
              readTime={Number(hit.article_read_time[0])}
              publicationDate={new Date(hit.created[0])}
            />
          );
        }}
      />

      <div className="mt-4">
        <SearchPagination
          previousLabel={t('buttons.previous')}
          nextLabel={t('buttons.next')}
        />
      </div>
    </div>
  );
};

export default SearchTopicalResultsArticles;
